import moment from "moment";
import { TitleHeroProps } from "../../../Components/Heros/TitleHero/title-hero";
import {
  FamilyMarkerDto,
  GetMarkersByObjectIdResponseDto,
  TypeMarkerDto,
} from "../../../Components/Panels/MarkerPanel/marker-and-clip-panel";
import {
  Distinct,
  DownloadFile,
  GetFormattedDateTime,
  LastIndex,
  UserHasAcl,
  UserHasAcls,
  UserHasLicence,
} from "../../../Utils/helpers";
import { GetMetadataByTagName, IsObjectShareable, IsPermissionGranted } from "../../Utils/asset-object-utils";
import GlobalConst from "../../Utils/Constants/globals";
import { GetAllChildMetadataDistinctByTagNameAndType } from "../../Utils/functions";
import ApiClient from "../api-client";
import { cacheService, EnvType, thumbnailService } from "../services";
import { ThumbnailSize } from "../Thumbnail/thumbnail-api-service";
import { AclAssetAccessLevel } from "../Types/acl-asset-access-level";
import { AclTypes } from "../Types/acl-types";
import { AddMarkerByObjectIdRequest } from "../Types/add-marker-by-object-id-request";
import { AddMarkerByObjectIdResponse } from "../Types/add-marker-by-object-id-response";
import { AddOrUpdateMarkersByObjectIdRequest } from "../Types/add-or-update-markers-by-object-id-request";
import {
  createTitleCoverResource,
  createTitlePosterResource,
  TitleCoverLocation,
  TitleCoverResource,
  TitlePosterLocation,
  TitlePosterResource,
} from "../Types/asset-resources";
import { BaseMetadataType } from "../Types/base-metadata-type";
import { ChangeStatusRequest } from "../Types/change-status-request";
import { CheckUpdateMetadataFieldsRequest } from "../Types/check-update-metadata-fields-request";
import { CheckUpdateMetadataFieldsResponse } from "../Types/check-update-metadata-fields-response";
import { CollectionRequest } from "../Types/collection-request";
import { CopyObjectRequest } from "../Types/copy-object-request";
import { CreateClipRequest } from "../Types/create-clip-request";
import { CreateClipResponse } from "../Types/create-clip-response";
import { CreateRequest } from "../Types/create-request";
import { CreateResponse } from "../Types/create-response";
import { CreateStandaloneRequest } from "../Types/create-standalone-request";
import { CreateStandaloneResponse } from "../Types/create-standalone-response";
import { DbAssetMarkerFamilyInfos } from "../Types/db-asset-marker-family-infos";
import { DbAssetMarkerTypeInfos } from "../Types/db-asset-marker-type-infos";
import {
  AdminAssetSingleActionsDto,
  AdminAssetSingleDto,
  AdminAssetSingleHierarchyDto,
  AdminAssetSingleMetadataDto,
  AssetMetadataRow,
  AssetMetadatas,
  AssetMetadataSection,
  AssetPanelDto,
  DataNodeType,
  DbAssetObjectInfos,
  TitleContentContent,
  TitleContentContentAudioByEpisode,
  TitleContentContentSubtitleByEpisode,
  TitleContentData,
  TreeGenBuilderItemNodeType,
} from "../Types/db-asset-object-infos";
import { CollectionLocation } from "../Types/db-collection-location";
import { CollectionType } from "../Types/db-collection-type";
import { DbMarkerCategory } from "../Types/db-marker-category";
import { DbMetadataFieldInfos } from "../Types/db-metadata-field-infos";
import { DbMetadataFieldValueInfos } from "../Types/db-metadata-field-value-infos";
import { DbObjectCollectionInfos } from "../Types/db-object-collection-infos";
import { ProviderHistoryModalDto } from "../Types/db-object-provider-history-infos";
import { StatusHistoryModalDto } from "../Types/db-object-status-history-infos";
import { DeleteSpecificPermissionRequest } from "../Types/delete-specific-permission-request";
import { DuplicateMarkerFromMarkerIdRequest } from "../Types/duplicate-marker-from-marker-id-request";
import { GenerateCompilationRequest } from "../Types/generate-compilation-request";
import { GenerateCompilationResponse } from "../Types/generate-compilation-response";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetObjectQuotasResponse } from "../Types/get-asset-object-quotas-response";
import { GetBundleMakerComputeMetadataRequest } from "../Types/get-bundle-maker-compute-metadata-request";
import { GetBundleMakerMetadataResponse } from "../Types/get-bundle-maker-metadata-response";
import { GetChildrenResponse } from "../Types/get-children-response";
import { GetChildrenSizeGroupedByObjectTypeResponse } from "../Types/get-children-size-grouped-by-object-type-response";
import { GetGraphResponse } from "../Types/get-graph-response";
import { GetLayerMetadataListResponse } from "../Types/get-layer-metadata-list-response";
import { GetMarkerEnumsResponse } from "../Types/get-marker-enums-response";
import { GetMarkersByObjectIdResponse } from "../Types/get-markers-by-object-id-response";
import { GetMetadataFieldsByObjectIdResponse } from "../Types/get-metadata-fields-by-object-id-response";
import { GetMetadataFieldsFlatResponse } from "../Types/get-metadata-fields-flat-response";
import { GetMetadataFieldsResponse } from "../Types/get-metadata-fields-response";
import { GetPermissionsByObjectIdResponse } from "../Types/get-permissions-by-object-id-response";
import { GetPlatformLanguageCodes } from "../Types/get-platform-language-codes";
import { GetStatusTransitionsResponse } from "../Types/get-status-transitions-response";
import { GroupAssetsRequest } from "../Types/group-assets-request";
import { ImportMarkersRequest } from "../Types/import-markers-request";
import { Languages } from "../Types/languages";
import { Licences } from "../Types/licences";
import { MetadataExportResponse } from "../Types/metadata-export-response";
import { MoveObjectRequest } from "../Types/move-object-request";
import { ObjectClass } from "../Types/object-class";
import { ObjectLayer } from "../Types/object-layer";
import { ObjectStatus } from "../Types/object-status";
import { ObjectType } from "../Types/object-type";
import { PermissionType } from "../Types/permission-type";
import { PlatformMode } from "../Types/platform-mode";
import { RenameRequest } from "../Types/rename-request";
import { SearchAdvancedResponse } from "../Types/search-advanced-response";
import { SearchResponse } from "../Types/search-response";
import { SetConfidentialityInfosRequest } from "../Types/set-confidentiality-infos-request";
import { SetDefaultPermissionsRequest } from "../Types/set-default-permissions-request";
import { SetFollowersRequest } from "../Types/set-followers-request";
import { SetSpecificPermissionsRequest } from "../Types/set-specific-permissions-request";
import { SetTagsPropertyRequest } from "../Types/set-tags-property-request";
import { SwitchClassRequest } from "../Types/switch-class-request";
import { UpdateCompilationRequest } from "../Types/update-compilation-request ";
import { UpdateMetadataFieldsRequest } from "../Types/update-metadata-fields-request";
import { UpdateMetadataResponse } from "../Types/update-metadata-response";
import { default as AssetApiClient, default as IAssetApiClient } from "./asset-api-client";
import { UpdateClipByIdRequest } from "../Types/update-clip-by-id-request";
import { UpdateObjectsMetadataFieldsRequest } from "../Types/update-objects-metadata-fields-request";
import { Console } from "console";

export default class AssetService {
  assetApiClient: IAssetApiClient;

  constructor(envType: EnvType) {
    this.assetApiClient = new AssetApiClient(new ApiClient(envType), envType);
  }

  //------Methods of Service------

  GetMatchingSearchItemsIdsFromTreeNode(
    node: TreeGenBuilderItemNodeType,
    parentNode: TreeGenBuilderItemNodeType | null,
    searchTerm: string
  ): string[] {
    // setup output array
    let output: string[] = [];
    //if node has childrens
    if (node.children && node.children.length) {
      // iterate through them
      for (let index = 0; index < node.children.length; index++) {
        // get ids of matching nodes
        output = output.concat(this.GetMatchingSearchItemsIdsFromTreeNode(node.children[index], node, searchTerm));
      }
    }

    if (
      // childrens are matching
      //output.length || // or
      // node is matching
      node.nodeId.includesAllWords(searchTerm) ||
      node.name.includesAllWords(searchTerm) ||
      (node.desc && node.desc.includesAllWords(searchTerm))
    ) {
      // add node id to list
      output.push(node.nodeId);
      // add parent to allow to go back to child opening parent nodes!
      if (parentNode) output.push(parentNode.nodeId);
    }

    // return array
    return output;
  }

  GetGraphIdsThatMatchObjectLayer(
    graph: DbAssetObjectInfos,
    layersToKeep: ObjectLayer[],
    idsToDisable: number[],
    keepParent: boolean = true
  ): [number[], number[]] {
    // stop condition => if no child
    if (!graph.childObjects?.length) {
      // if item isn't disabled and is in wanted layers => returns its id
      if (!idsToDisable.includes(graph.id) && layersToKeep.includes(graph.layer)) return [[graph.id], []];
      // if not return empty array
      return [[], []];
    }
    // init output
    let output: [number[], number[]] = [[], []];
    // if node has childs
    // loop on childs
    for (let i = 0; i < graph.childObjects.length; i++) {
      const child = graph.childObjects[i];
      // get child data
      const _childArray = this.GetGraphIdsThatMatchObjectLayer(child, layersToKeep, idsToDisable, keepParent);
      output[0] = output[0].concat(_childArray[0]);
      output[1] = output[1].concat(_childArray[1]);
    }
    // if this node is in wanted layers => add node id to first array
    if (!idsToDisable.includes(graph.id) && layersToKeep.includes(graph.layer)) {
      output[0].push(graph.id);
    } else {
      // else, if some child is in wanted layers, add node id to second array
      if (output[0].length) output[1].push(graph.id);
    }

    return output;
  }

  GetTreeGenBuilderItemNodeTypeFromObject(obj: DbAssetObjectInfos, isTarPreview = false): TreeGenBuilderItemNodeType[] {
    const node = this.ConvertObjectToDataTree(obj, isTarPreview);
    return [this.ConvertDataNodeTypeToTreeGen(node)];
  }

  GetTitleContentDataFromAssetObject(
    response: GetGraphResponse,
    metadataList?: DbMetadataFieldInfos[]
  ): TitleContentData {
    if (!metadataList) metadataList = cacheService.GetMetadata();

    // Prepare utils
    const titleContentData: TitleContentData = {
      id: response.graph!.id,
      name: response.graph!.name || "-",
      hasConfidentialityInfos:
        response.graph!.confidentialityInfos !== undefined && response.graph!.confidentialityInfos !== null,
      comment: response.graph!.comment || "-",
      isSerieTitle: false,
      casting: {},
      content: [],
      allLang: [],
      metadataSections: response.views ? this.getAssetMetadatasFromGetGraphResponse(response) : null,
      tags: response.graph?.tags ?? [],
      metadataList: {
        titleType: GetMetadataByTagName(response.graph!, "titleType", metadataList),
        serieSeasonEpisodeTotalNumber: GetMetadataByTagName(
          response.graph!,
          "serieSeasonEpisodeTotalNumber",
          metadataList
        ),
        allVideoQualities: GetMetadataByTagName(response.graph!, "allVideoQualities", metadataList),
        duration: GetMetadataByTagName(response.graph!, "duration", metadataList),
        programRestored: GetMetadataByTagName(response.graph!, "programRestored", metadataList),
        allAudioLanguages: GetMetadataByTagName(response.graph!, "allAudioLanguages", metadataList),
        allAudioVersions: GetMetadataByTagName(response.graph!, "allAudioVersions", metadataList),
        allSubtitleLanguages: GetMetadataByTagName(response.graph!, "allSubtitleLanguages", metadataList),
        imdbId: GetMetadataByTagName(response.graph!, "imdbId", metadataList),
        titleOriginalPictureFormat: GetMetadataByTagName(response.graph!, "titleOriginalPictureFormat", metadataList),
        productionDate: GetMetadataByTagName(response.graph!, "productionDate", metadataList),
        titleOriginalLanguage: GetMetadataByTagName(response.graph!, "titleOriginalLanguage", metadataList),
        titleSecondaryOriginalLanguages: GetMetadataByTagName(
          response.graph!,
          "titleSecondaryOriginalLanguages",
          metadataList
        ),
        nationalities: GetMetadataByTagName(response.graph!, "nationalities", metadataList),
        titleGenres: GetMetadataByTagName(response.graph!, "titleGenres", metadataList),
        titles: GetMetadataByTagName(response.graph!, "titles", metadataList),
        synopses: GetMetadataByTagName(response.graph!, "synopses", metadataList),
        note: GetMetadataByTagName(response.graph!, "note", metadataList),
      },
    };

    // Checking if Title is Movie or Serie
    if (titleContentData.metadataList.titleType?.value !== "Movie") {
      titleContentData.isSerieTitle = true;
    }

    // Casting
    const castsMetadata = GetMetadataByTagName(response.graph!, "casts", metadataList);
    if (castsMetadata) {
      titleContentData.casting = Object.assign(
        {},
        ...castsMetadata?.value.map((x: any) => ({
          [x.function]: [],
        }))
      );

      // Note: do not push localized values
      castsMetadata?.value
        .filter((x) => x.languageLocalizedCultureId === null)
        .forEach((x: any) => {
          let value = x.lastname;
          if (x.lastname !== x.name) value = `${x.name} ${value}`;

          titleContentData.casting[x.function].push(value);
        });
    }

    // Content
    response.graph?.childObjects
      ?.filter((x) => x.status !== ObjectStatus.Deleted)
      ?.forEach((element: DbAssetObjectInfos) => {
        if (
          cacheService.GetGroup()?.aclAssetAccessLevel === AclAssetAccessLevel.Asset &&
          !element.childObjects?.some(
            (x) => x.status === ObjectStatus.Accepted && x.classification === ObjectClass.Mezz
          )
        )
          return;

        let listEpisodeNb: number[] = [];

        const subTypes = ["Program", "Program Restored"];

        const audios: TitleContentContentAudioByEpisode[] = [];
        const subtitles: TitleContentContentSubtitleByEpisode[] = [];

        element.childObjects
          ?.filter(
            (c) =>
              c.layer === ObjectLayer.Asset &&
              c.classification === ObjectClass.Mezz &&
              c.status === ObjectStatus.Accepted &&
              c.type === ObjectType.Video &&
              subTypes.includes(GetMetadataByTagName(c, "contentSubType")?.value)
          )
          .forEach((c) => {
            const episodeNumberOfAsset = titleContentData.isSerieTitle
              ? GetMetadataByTagName(c, "serieEpisodeNumberProduction", metadataList)?.value
              : 0;
            if (episodeNumberOfAsset !== 0 && listEpisodeNb.indexOf(episodeNumberOfAsset) === -1)
              listEpisodeNb.push(episodeNumberOfAsset);
          });

        listEpisodeNb = listEpisodeNb.filter(Distinct);
        // Audio and Subtitle content data
        element.childObjects
          ?.filter(
            (c) =>
              c.layer === ObjectLayer.Asset &&
              c.classification === ObjectClass.Mezz &&
              c.status === ObjectStatus.Accepted &&
              [ObjectType.Video, ObjectType.Audio, ObjectType.Subtitle].includes(c.type) &&
              subTypes.includes(GetMetadataByTagName(c, "contentSubType")?.value)
          )
          .forEach((child) => {
            const episodeNumberOfAsset = titleContentData.isSerieTitle
              ? GetMetadataByTagName(child, "serieEpisodeNumberProduction", metadataList)?.value
              : 0;

            let audioByEpisodeIndex = audios.findIndex((a) => a.episodeNb === episodeNumberOfAsset);
            if (audioByEpisodeIndex === -1) {
              audios.push({
                episodeNb: episodeNumberOfAsset,
                audios: [],
              });
              audioByEpisodeIndex = audios.length - 1;
            }

            let subtitleByEpisodeIndex = subtitles.findIndex((a) => a.episodeNb === episodeNumberOfAsset);
            if (!subtitles.some((a) => a.episodeNb === episodeNumberOfAsset)) {
              subtitles.push({
                episodeNb: episodeNumberOfAsset,
                subtitles: [],
              });
              subtitleByEpisodeIndex = subtitles.length - 1;
            }

            if (child.type === ObjectType.Video || child.type === ObjectType.Audio) {
              const lang = GetMetadataByTagName(child, "languageAudio", metadataList)?.value.value;
              if (!lang) return;

              if (!audios[audioByEpisodeIndex].audios.some((a) => a.lang === lang)) {
                audios[audioByEpisodeIndex].audios.push({
                  lang: lang,
                  mixes: [],
                  accesses: [],
                });
              }

              const audioIndex = audios[audioByEpisodeIndex].audios.findIndex((a) => a.lang === lang);
              const mix = GetMetadataByTagName(child, "audioMix", metadataList)?.value;
              const access = GetMetadataByTagName(child, "audioMixOverallAccess", metadataList)?.value;

              if (mix && !audios[audioByEpisodeIndex].audios[audioIndex].mixes.includes(mix))
                audios[audioByEpisodeIndex].audios[audioIndex].mixes.push(mix);
              if (access && !audios[audioByEpisodeIndex].audios[audioIndex].accesses.includes(access))
                audios[audioByEpisodeIndex].audios[audioIndex].accesses.push(access);
            } else if (child.type === ObjectType.Subtitle) {
              const lang = GetMetadataByTagName(child, "languageSubtitle", metadataList)?.value.value;
              if (!lang) return;
              if (!subtitles[subtitleByEpisodeIndex].subtitles.some((a) => a.lang === lang)) {
                subtitles[subtitleByEpisodeIndex].subtitles.push({
                  lang: lang,
                  types: [],
                });
              }

              const subtitleIndex = subtitles[subtitleByEpisodeIndex].subtitles.findIndex((a) => a.lang === lang);
              const type = GetMetadataByTagName(child, "subtitleType", metadataList)?.value;
              const sdh = GetMetadataByTagName(child, "subtitleSME", metadataList)?.value;
              if (type && !subtitles[subtitleByEpisodeIndex].subtitles[subtitleIndex].types.includes(type)) {
                const value = sdh ? `${type} (SDH)` : type;
                if (!subtitles[subtitleByEpisodeIndex].subtitles[subtitleIndex].types.includes(value))
                  subtitles[subtitleByEpisodeIndex].subtitles[subtitleIndex].types.push(value);
              }
            }
          });

        const tmp: TitleContentContent = {
          id: element.id,
          title: element.name,
          qualities:
            GetAllChildMetadataDistinctByTagNameAndType(
              element,
              "videoProfile",
              ["Video" as ObjectType],
              false,
              false,
              metadataList,
              subTypes
            ) || null,
          audio: audios,
          subtitles: subtitles,
          path: [element?.name],
          duration: GetMetadataByTagName(element, "durationSMPTE", metadataList)?.value || "-",
          allLang: [
            ...new Set([
              ...GetAllChildMetadataDistinctByTagNameAndType(
                element,
                "languageSubtitle",
                ["Subtitle" as ObjectType],
                true,
                true,
                metadataList,
                subTypes
              ),
              ...GetAllChildMetadataDistinctByTagNameAndType(
                element,
                "languageAudio",
                ["Video" as ObjectType, "Audio" as ObjectType],
                true,
                true,
                metadataList,
                subTypes
              ),
              ...GetAllChildMetadataDistinctByTagNameAndType(
                element,
                "languageAudioSecondary",
                ["Video" as ObjectType, "Audio" as ObjectType],
                true,
                true,
                metadataList,
                subTypes
              ),
            ]),
          ],
          episodeNb: [],
        };

        tmp.allLang.forEach((element) => {
          if (!titleContentData.allLang.includes(element)) titleContentData.allLang.push(element);
        });

        titleContentData.content.push({
          id: tmp.id,
          title: tmp.title,
          qualities: tmp.qualities,
          audio: tmp.audio,
          subtitles: tmp.subtitles,
          path: tmp.path,
          duration: tmp.duration,
          allLang: tmp.allLang,
          episodeNb: listEpisodeNb.sort(function (a, b) {
            return a > b ? 1 : -1;
          }),
        });
      });

    // Related Titles
    if (
      response.graph?.relatedObjects !== null &&
      response.graph?.relatedObjects !== undefined &&
      response.graph?.relatedObjects.length > 0
    ) {
      titleContentData.relatedTitles = response.graph?.relatedObjects.map((movie) => ({
        id: movie.id,
        to: "#",
        cover: thumbnailService.GetObjectPosterUrl(movie.id),
        title: movie.name ? movie.name : "",
        labelList: movie.status ? [movie.status] : [""],
        quality: "",
        favorite: false,
        expand: {
          contentList: [],
          audioList: [],
          subtitleList: [],
          tagList: [],
          quality: "",
        },
      }));
    }

    return titleContentData;
  }

  GetTitleDataFromAssetObject(obj: DbAssetObjectInfos): [TitleHeroProps, TitleContentData] {
    const metadataList: DbMetadataFieldInfos[] = cacheService.GetMetadata();
    const titleContentData = this.GetTitleContentDataFromAssetObject(
      {
        graph: obj,
        layer: null,
        views: null,
        hierarchy: null,
        success: true,
        rescode: 0,
        objectId: obj.id,
        message: null,
      },
      metadataList
    );

    // Hero title data
    var actors: string[] | undefined;
    titleContentData.casting["Actor"]
      ? (actors = Object.values(titleContentData.casting["Actor"]))
      : (actors = undefined);
    const syno = GetMetadataByTagName(obj, "synopses", metadataList)?.value;
    const ol = GetMetadataByTagName(obj, "titleOriginalLanguage", metadataList)?.value;

    const heroData: TitleHeroProps = {
      id: obj?.id,
      title: obj?.name,
      type: GetMetadataByTagName(obj, "titleType", metadataList)?.value,
      cover: thumbnailService.GetObjectPosterUrl(obj.id, ThumbnailSize.xxlarge),
      description: syno
        ? ol && syno.find((x) => x.languageCode !== null && x.languageCode.value === ol.value)
          ? syno.find((x) => x.languageCode !== null && x.languageCode.value === ol.value).text
          : syno[0].text
        : "",
      casting: actors,
      content: String(titleContentData.content?.length),
      genre: GetMetadataByTagName(obj, "titleGenres", metadataList)?.value,
      tags: GetMetadataByTagName(obj, "allVideoQualities", metadataList)?.value,
    };

    return [heroData, titleContentData];
  }

  GetAdminAssetSingleDtoFromAssetObject(asset: DbAssetObjectInfos): AdminAssetSingleDto {
    const [rejectedBy, rejectedAt, rejectedComment] = this.getRejectedInfosFromAsset(asset);
    const [bypassedBy, bypassedAt, bypassedComment] = this.getInfosFromAsset(asset, ObjectStatus.Accepted);
    const [deletedBy, deletedAt, deletedComment] = this.getInfosFromAsset(asset, ObjectStatus.Deleted);

    const isBypassed = GetMetadataByTagName(asset, "ingestQCBypassed");
    const providerName = asset.providerName || "-";
    const providerId = asset.providerId;

    const userCanEditMetadata = this.getHasRightToEditMetadata(asset);
    const userCanAddNewAssignment = this.getHasRightToAddNewAssignment(asset);
    const userCanDeleteRequest = this.getHasRightToDeleteRequest(asset);

    const platformMode = cacheService.GetPlatformMode();

    let dkdm: DbAssetObjectInfos | undefined = undefined;

    if (asset.type === ObjectType.DcpPackage) {
      dkdm = asset.childObjects
        ?.find((x) => x.type === ObjectType.KdmContainer)
        ?.childObjects?.find(
          (x) =>
            x.status === ObjectStatus.Accepted &&
            GetMetadataByTagName(x, "dcpKdmIsInternalDkdm")?.value &&
            moment(GetMetadataByTagName(x, "dcpKdmStartDate")?.value) < moment() &&
            moment(GetMetadataByTagName(x, "dcpKdmEndDate")?.value) > moment()
        );
    }

    return {
      id: asset.id,
      status: GetMetadataByTagName(asset, "isDisabled")?.value ? ObjectStatus.Disabled : asset.status,
      statusHistory: asset.statusHistory ?? [],
      type: asset.type,
      layer: asset.layer,
      class: asset.classification,
      name: asset.nameAlt ?? asset.name,
      parentTitleId: asset.parentTitleId,
      parentTitleName: asset.parentTitleName,
      parentTitleLayer: asset.parentTitle?.layer ?? ObjectLayer.Title,
      isAssetUploadable: this.getIsAssetUploadable(asset),
      topbarData: {
        providerHistory: this.getProviderHistoryData(asset),
        statusHistory: this.getStatusHistoryData(asset),
        userCanAddToBasket: this.getHasRightToAddBasket(asset),
        userCanCreateShare: this.getHasRightToCreateShare(asset),
        userCanExportXml: this.getHasRightToExportXml(asset),
        userCanExportPdf: this.getHasRightToExportPdf(asset),
        userCanEditMetadata: userCanEditMetadata,
        dcpDkdmObjectId: dkdm ? dkdm.id : null,
      },
      rejectionDetails: {
        rejectedBy: rejectedBy || "-",
        rejectedAt: rejectedAt || "-",
        rejectedComment: rejectedComment || "-",
        assignedProviderId: providerId,
        assignedProviderName: providerName,
        userCanPurge: this.getHasRightToPurge(asset),
        userCanEditMetadata: userCanEditMetadata,
        userCanAddNewAssignment: userCanAddNewAssignment,
        userCanDeleteRequest: userCanDeleteRequest,
        userCanBypassReject: this.getHasRightToByPassRejection(asset),
        currentStatus: asset.status,
      },
      requestDetails: {
        requestedBy: asset.creationInfos?.userName || "-",
        requestedAt: GetFormattedDateTime(asset.creationInfos?.date) || "-",
        assignedProviderId: providerId,
        assignedProviderName: providerName,
        userCanRemindProvider: this.getHasRightToRemindProvider(asset),
        userCanAddNewAssignment: userCanAddNewAssignment,
        userCanDeleteRequest: userCanDeleteRequest,
      },
      bypassDetails: {
        bypassedBy: bypassedBy || "-",
        bypassedAt: bypassedAt || "-",
        bypassedComment: bypassedComment || "-",
        assignedProviderName: providerName,
      },
      deleteDetails: {
        deletedBy: deletedBy || "-",
        deletedAt: deletedAt || "-",
        deletedComment: deletedComment || "-",
        assignedProviderName: providerName,
      },
      dcpDkdmObjectId: dkdm ? dkdm.id : null,
      isBypassed: isBypassed ? true : false,
      isTrailer: GetMetadataByTagName(asset, "adamAssetType")?.value === "trailer",
      metadata: asset.metadata ?? undefined,
    };
  }

  async DownloadTitleAsExcelFile(titleId: number): Promise<GenericResponseStd> {
    return await this.assetApiClient.DownloadTitleAsExcelFile(titleId);
  }

  async DownloadTitleMetadata(titleId: number, includeChildren: boolean): Promise<boolean> {
    const response = await this.assetApiClient.ExportObjectMetadata(titleId, includeChildren);
    if (!response.success || !response.data) return false;
    DownloadFile(response.data, "text/xml", `${titleId}.xml`);
    return true;
  }

  async ExportAssetAsPdf(assetId: number, language: Languages, markerCategory?: DbMarkerCategory): Promise<boolean> {
    const [fileData, headers] = await this.assetApiClient.DownloadAssetPdfExport(assetId, language, markerCategory);

    if (!fileData || fileData.length === 0) return false;
    const headerContentDisp = headers["content-disposition"];
    let fileName = `${assetId}.pdf`;
    const headerStartsWith = "attachment; filename=";
    if (headerContentDisp && headerContentDisp.includes(headerStartsWith)) {
      const split = headerContentDisp.substring(headerStartsWith.length).split(";");
      fileName = split[0];
    }

    DownloadFile(fileData, "application/pdf", fileName);

    return true;
  }

  async ExportAssetAsXml(assetId: number, includeChildren: boolean): Promise<{ success: boolean; message: string }> {
    const response = await this.assetApiClient.ExportObjectMetadata(assetId, includeChildren);

    if (!response.success || !response.data)
      return {
        success: response.success || false,
        message: response.message || "Something went wrong",
      };

    DownloadFile(response.data, "text/xml", `${assetId}.xml`);

    return {
      success: true,
      message: "Succesful XML generation",
    };
  }

  GetAdminAssetSingleMetadataDtoFromGraphResponse(response: GetGraphResponse): AdminAssetSingleMetadataDto | undefined {
    if (!response.graph) return undefined;
    const asset = response.graph;
    return {
      parentTitleId: asset.parentTitleId,
      parentTitleName: asset.parentTitleName || "-",
      parentTitleLayer: asset.parentTitle?.layer ?? ObjectLayer.Title,
      parentObjectId: asset.parentObjectId,
      parentObjectName: asset.parentObject?.name || "-",
      name: asset.name || "-",
      type: asset.type,
      class: asset.classification,
      metadatas: this.getAssetMetadatasFromGetGraphResponse(response),
    };
  }

  GetAdminAssetSingleHierarchyDtoFromGraphResponse(
    response: GetGraphResponse
  ): AdminAssetSingleHierarchyDto | undefined {
    if (!response.graph || !response.hierarchy) return undefined;

    return {
      hierarchyTree: response.hierarchy,
      graph: response.graph,
    };
  }

  GetAdminAssetSingleActionsDtoFromAssetObject(asset: DbAssetObjectInfos): AdminAssetSingleActionsDto {
    let mode: PlatformMode = cacheService.GetPlatformMode();

    return {
      id: asset.id,
      name: asset.name,
      classification: asset.classification!,
      status: asset.status,
      type: asset.type,
      layer: asset.layer,
      currentFollowersIds: asset.followersInfos?.flatMap((follower) => follower.id) || [],
      userHasAclSuperUser: UserHasAcl(AclTypes.aclSuperUser),
      userHasRightToSwitchClass: this.getHasRightToSwitchClass(asset) && mode === PlatformMode.Distribution,
      userHasRightToChangeStatus: this.getHasRightToChangeStatus(asset),
      userHasRightToRequalifyAsset: this.getHasRightToRequalifyAsset(asset) && mode === PlatformMode.Distribution,
      userHasRightToOrderQCCheck: this.getHasRightToOrderQCCheck(asset) && mode === PlatformMode.Distribution,
      userHasRightToStartJob: this.getHasRightToStartJob(asset),
      userHasRightToStartWorkflow: this.getHasRightToStartWorkflow(asset),
      userHasRightToPurgeMediaFiles: this.getHasRightToPurge(asset),
      userHasRightToDelete: this.getHasRightToDelete(asset),
    };
  }

  async GetAssetForAssetPanel(objectId: number): Promise<AssetPanelDto | undefined> {
    const response = await this.assetApiClient.GetObjectLightById(objectId, 0);
    const assetObject = response.graph;

    if (assetObject === undefined || assetObject === null) return;

    const [rejectedBy, rejectedAt, rejectedComment] = this.getRejectedInfosFromAsset(assetObject);
    const [deletedBy, deletedAt, deletedComment] = this.getInfosFromAsset(assetObject, ObjectStatus.Deleted);
    const [bypassedBy, bypassedAt, bypassedComment] = this.getInfosFromAsset(assetObject, ObjectStatus.Accepted);

    const [ingestDate, acceptationDate] = this.getIngestDateAndAcceptationDate(assetObject);
    const isBypassed = GetMetadataByTagName(assetObject, "ingestQCBypassed");

    return {
      id: assetObject.id,
      status: assetObject.status,
      type: assetObject.type,
      rejectedBy: rejectedBy,
      rejectedAt: rejectedAt,
      rejectedComment: rejectedComment,
      deletedBy: deletedBy,
      deletedAt: deletedAt,
      deletedComment: deletedComment,
      bypassedBy: bypassedBy,
      bypassedAt: bypassedAt,
      bypassedComment: bypassedComment,
      isBypassed: isBypassed ? true : false,
      userCanPurge: this.getHasRightToPurge(assetObject),
      userCanBypassReject: this.getHasRightToByPassRejection(assetObject),
      globalInfos: {
        title: `${assetObject.parentTitleName ? assetObject.parentTitleName + " / " : ""}${
          assetObject.parentObject!.name
        }`,
        assetName: assetObject.name,
        classification: assetObject.classification!,
        requestedBy: assetObject.creationInfos!.userName!,
        requestedAt: GetFormattedDateTime(assetObject.creationInfos!.date!),
        assignedProviderName: assetObject.providerName || "-",
        followedByUserNames: assetObject.followedByUserNames || "-",
        ingestDate: ingestDate,
        uploadedVia: assetObject.uploadedByUserName || "-",
        acceptationDate: acceptationDate,
        placeholderRowId: assetObject.placeholderRowId,
      },
      assetMetadata: this.getAssetMetadatasFromGetGraphResponse(response),
      assetMedia: [],
    };
  }

  async GetGraph(
    objectId: number,
    extended: boolean = false,
    light: boolean = false,
    visit: boolean = false
  ): Promise<GetGraphResponse> {
    if (light && visit) return await this.assetApiClient.GetGraphExtendedLightNoVisitByObjectId(objectId);
    else if (light) return await this.assetApiClient.GetGraphExtendedLightByObjectId(objectId);
    else if (extended) return await this.assetApiClient.GetGraphExtendedByObjectId(objectId);
    else return await this.assetApiClient.GetGraphByObjectId(objectId);
  }

  //------Private------

  private ConvertDataNodeTypeToTreeGen(node: DataNodeType): TreeGenBuilderItemNodeType {
    const treeChildrenNodeIds: string[] = [];

    const _getChildrenNodeIds = (nodeId: string | undefined, node: DataNodeType) => {
      if (nodeId !== undefined) {
        treeChildrenNodeIds.push(nodeId);
      }

      node.children?.forEach((childNode) => {
        _getChildrenNodeIds(childNode.nodeId, childNode);
      });
    };

    _getChildrenNodeIds(undefined, node);

    return {
      ...node,
      treeChildrenNodeIds,
      type: node.type,
      poster: node.poster,
      name: node.name,
      desc: node.desc,
      children: node.children ? node.children.map((childNode) => this.ConvertDataNodeTypeToTreeGen(childNode)) : [],
    };
  }

  private ConvertObjectToDataTree(obj: DbAssetObjectInfos, isTarPreview = false): DataNodeType {
    return {
      type:
        obj.layer === ObjectLayer.Title
          ? "Title"
          : obj.layer === ObjectLayer.Group || obj.layer === ObjectLayer.Content || obj.layer === ObjectLayer.SubContent
          ? "Group"
          : "Asset",
      poster: obj.layer === ObjectLayer.Title ? thumbnailService.GetObjectPosterUrl(obj.id, ThumbnailSize.small) : null,
      nodeId: obj.id.toString(),
      name: isTarPreview
        ? ``
        : obj.layer === ObjectLayer.Title || obj.layer === ObjectLayer.Group
        ? obj.name!
        : obj.layer === ObjectLayer.Content || obj.layer === ObjectLayer.SubContent
        ? `${obj.layer} ${obj.name}`
        : `#${obj.id}`,
      desc: isTarPreview
        ? `${obj.name}`
        : obj.layer === ObjectLayer.Asset
        ? obj.name!
        : `${
            obj.childObjects && obj.childObjects.length > 0
              ? obj.childObjects.length % GlobalConst.MAX_CHILDREN === 0
                ? `${obj.childObjects.length - 1}+`
                : obj.childObjects.length
              : "0"
          }`,
      children: obj.childObjects ? obj.childObjects.map((x) => this.ConvertObjectToDataTree(x, isTarPreview)) : [],
      objectType: obj.type!,
    };
  }

  private getIsAssetUploadable(asset: DbAssetObjectInfos): boolean {
    return (
      asset.type !== ObjectType.Group &&
      asset.type !== ObjectType.GroupMasterDcp &&
      asset.type !== ObjectType.GroupMasterImf &&
      asset.type !== ObjectType.Folder &&
      asset.type !== ObjectType.GraphSkeleton &&
      IsPermissionGranted(asset, PermissionType.CreateObject)
    );
  }

  private getStatusHistoryData(assetObject: DbAssetObjectInfos): StatusHistoryModalDto[] {
    const output: StatusHistoryModalDto[] = [];

    if (assetObject.statusHistory)
      for (let index = 0; index < assetObject.statusHistory.length; index++) {
        const element = assetObject.statusHistory[index];
        if (!element.status) continue;
        output.push({
          // needed for mui datagrid
          id: index,
          date: GetFormattedDateTime(element.date),
          message: element.comment || "-",
          status: element.status,
          user: element.isSystem || element.userName === "Unknown" ? "System" : element.userName || "-",
        });
      }
    return output;
  }

  private getProviderHistoryData(assetObject: DbAssetObjectInfos): ProviderHistoryModalDto[] {
    const output: ProviderHistoryModalDto[] = [];

    if (assetObject.providerHistory)
      for (let index = 0; index < assetObject.providerHistory.length; index++) {
        const element = assetObject.providerHistory[index];

        output.push({
          // needed for mui datagrid
          id: index,
          date: GetFormattedDateTime(element.date),
          provider: element.providerName || "-",
          user: element.userName || "-",
        });
      }

    return output;
  }

  private getHasRightToSwitchClass(assetObject: DbAssetObjectInfos): boolean {
    return (
      (assetObject.classification === ObjectClass.Mezz && UserHasAcl(AclTypes.aclSwitchClassToRaw)) ||
      (assetObject.classification === ObjectClass.Raw && UserHasAcl(AclTypes.aclSwitchClassToMezz)) ||
      (UserHasAcl(AclTypes.aclElevationWishlistCreate) &&
        (assetObject.type === ObjectType.Video ||
          assetObject.type === ObjectType.Audio ||
          assetObject.type === ObjectType.Subtitle))
    );
  }
  private getHasRightToChangeStatus(assetObject: DbAssetObjectInfos): boolean {
    return (
      UserHasAcl(AclTypes.aclSuperUser) ||
      (UserHasAcl(AclTypes.aclObjectChangeStatus) && cacheService.GetPlatformMode() === PlatformMode.Adam)
    );
  }
  private getHasRightToRequalifyAsset(assetObject: DbAssetObjectInfos): boolean {
    return (
      UserHasAcl(AclTypes.aclWorkflowQualifyCreate) &&
      assetObject.classification !== ObjectClass.Raw &&
      (assetObject.status === ObjectStatus.Accepted || assetObject.status === ObjectStatus.NeedCheckOrEditing)
    );
  }
  // (graph.status != 'Accepted' && graph.status != 'NeedCheckOrEditing' || (graph.classification == 'Raw'))
  private getHasRightToOrderQCCheck(assetObject: DbAssetObjectInfos): boolean {
    return (
      (assetObject.type === ObjectType.Video ||
        assetObject.type === ObjectType.Audio ||
        assetObject.type === ObjectType.ImageSequence) &&
      UserHasAcl(AclTypes.aclOrderQualityCheckCreate)
    );
  }
  private getHasRightToStartJob(assetObject: DbAssetObjectInfos): boolean {
    return UserHasAcl(AclTypes.aclSuperUser) || UserHasAcl(AclTypes.aclJobRuleApply);
  }
  private getHasRightToStartWorkflow(assetObject: DbAssetObjectInfos): boolean {
    return UserHasAcl(AclTypes.aclSuperUser);
  }
  private getHasRightToRemindProvider(assetObject: DbAssetObjectInfos): boolean {
    return UserHasAcl(AclTypes.aclIngestPlaceholderRemind);
  }
  private getHasRightToDeleteRequest(assetObject: DbAssetObjectInfos): boolean {
    return UserHasAcls([AclTypes.aclIngestDeleteRequest, AclTypes.aclElevationWishlistCreate]);
  }

  private getHasRightToAddNewAssignment(assetObject: DbAssetObjectInfos): boolean {
    return UserHasAcl(AclTypes.aclIngestAssignToLabProvider);
  }

  getHasRightToCreateShare(assetObject: DbAssetObjectInfos): boolean {
    return (
      IsObjectShareable(assetObject) &&
      UserHasAcl(AclTypes.aclShareCreate) &&
      (assetObject.parentTitle?.confidentialityInfos === undefined ||
        assetObject.parentTitle?.confidentialityInfos === null ||
        UserHasAcl(AclTypes.aclTitleConfidentialityOrders)) &&
      IsPermissionGranted(assetObject, PermissionType.Share) &&
      UserHasLicence(Licences.ShareScreening)
    );
  }

  private getHasRightToExportPdf(assetObject: DbAssetObjectInfos): boolean {
    return UserHasAcl(AclTypes.aclAssetPdfExport);
  }
  private getHasRightToExportXml(assetObject: DbAssetObjectInfos): boolean {
    return UserHasAcl(AclTypes.aclMetadataExport);
  }

  getHasRightToEditMetadata(assetObject: DbAssetObjectInfos): boolean {
    return (
      (assetObject.status === ObjectStatus.New
        ? UserHasAcl(AclTypes.aclIngestUpload)
        : (assetObject.status === ObjectStatus.Accepted
            ? UserHasAcl(AclTypes.aclMetadataUpdateWithAcceptedAssetStatus)
            : UserHasAcl(AclTypes.aclMetadataUpdate)) ||
          UserHasAcl(AclTypes.aclMetadataExport) ||
          UserHasAcl(AclTypes.aclSuperUser)) && IsPermissionGranted(assetObject, PermissionType.MetadataEdit)
    );
  }

  getHasRightToAddBasket(assetObject: DbAssetObjectInfos): boolean {
    let statuses = [
      ObjectStatus.Accepted,
      ObjectStatus.ToBeQCed,
      ObjectStatus.WaitingForMEZZReference,
      ObjectStatus.Rejected,
      ObjectStatus.RejectedAuto,
      ObjectStatus.QualityCheckInProgress,
    ];

    if (cacheService.GetPlatformMode() === PlatformMode.Adam) {
      statuses.push(ObjectStatus.NeedCheckOrEditing);
      statuses.push(ObjectStatus.AcceptedForBroadcast);
      statuses.push(ObjectStatus.Broadcasted);
      statuses.push(ObjectStatus.Delivered);
    }

    return (
      statuses.includes(assetObject.status) &&
      (assetObject.parentTitle?.confidentialityInfos === undefined ||
        assetObject.parentTitle?.confidentialityInfos === null ||
        UserHasAcl(AclTypes.aclTitleConfidentialityOrders)) &&
      IsPermissionGranted(assetObject, PermissionType.Download)
    );
  }

  private getHasRightToPurge(assetObject: DbAssetObjectInfos): boolean {
    return (
      assetObject.layer === ObjectLayer.Asset &&
      assetObject.status !== ObjectStatus.RejectedAuto &&
      assetObject.status !== ObjectStatus.Deleted &&
      assetObject.type !== ObjectType.MetadataDcpKdm &&
      (UserHasAcl(AclTypes.aclElevationWishlistCreate) ||
        (assetObject.status === ObjectStatus.Accepted
          ? UserHasAcl(AclTypes.aclWorkflowPurgeCreateWithAcceptedAssetStatus)
          : UserHasAcl(AclTypes.aclWorkflowPurgeCreate)))
    );
  }

  private getHasRightToDelete(assetObject: DbAssetObjectInfos): boolean {
    let modeDistrib = cacheService.GetPlatformMode() === PlatformMode.Distribution;
    let distribRuleCheck =
      assetObject.status === ObjectStatus.New ||
      assetObject.status === ObjectStatus.RejectedAuto ||
      assetObject.status === ObjectStatus.Rejected ||
      assetObject.type === ObjectType.MetadataDcpKdm;

    return (
      (assetObject.layer === ObjectLayer.Asset &&
        UserHasAcl(AclTypes.aclAssetDelete) &&
        (!modeDistrib || (modeDistrib && distribRuleCheck))) ||
      (assetObject.layer === ObjectLayer.Clip && UserHasAcl(AclTypes.aclClipDelete))
    );
  }

  private getHasRightToByPassRejection(asset: DbAssetObjectInfos): boolean {
    return (
      UserHasAcls([AclTypes.aclIngestRejectionsBypass, AclTypes.aclElevationWishlistCreate]) &&
      (GetMetadataByTagName(asset, "ingestQCAllowBypass")?.value ?? false)
    );
  }

  private getAssetMetadatasFromGetGraphResponse(response: GetGraphResponse): AssetMetadatas {
    if (!response || !response.views || response.views.length === 0) return { sections: [] };

    const view = response.views[0];
    const assetMetadataToReturn: AssetMetadatas = { sections: [] };

    view.groups?.forEach((group) => {
      const output: AssetMetadataSection = {
        icon: group.icon || "",
        name: group.name!["en-UK"] ?? group.name!["fr-FR"],
        rows: [],
      };

      const metadataFields = group.rows?.flatMap((x) => x.columns?.flatMap((x) => x.metadataFields));

      metadataFields?.forEach((metadata) => {
        const label = metadata?.label;
        const metadataValue = GetMetadataByTagName(response.graph, metadata!.tagName!);

        if (label)
          output.rows.push({
            tagName: metadata.tagName!,
            label,
            value: metadataValue?.value,
            type: metadata.baseType!,
            id: metadata.id,
          });
      });

      assetMetadataToReturn.sections.push(output);
    });
    return assetMetadataToReturn;
  }

  private getIngestDateAndAcceptationDate(assetObject: DbAssetObjectInfos): [string, string] {
    if (assetObject.statusHistory === null) return ["-", "-"];

    const lastIndexOfParsedAndProbbed = LastIndex(assetObject.statusHistory, "status", "ParsedAndProbbed");
    const lastIndexOfAccepted = LastIndex(assetObject.statusHistory, "status", "Accepted");

    let ingestDate = "-";
    let acceptationDate = "-";

    if (lastIndexOfParsedAndProbbed !== -1) {
      ingestDate = GetFormattedDateTime(assetObject.statusHistory[lastIndexOfParsedAndProbbed]!.date);
    }

    if (lastIndexOfAccepted !== -1) {
      acceptationDate = GetFormattedDateTime(assetObject.statusHistory[lastIndexOfAccepted]!.date);
    }

    return [ingestDate, acceptationDate];
  }
  private getRejectedInfosFromAsset(assetObject: DbAssetObjectInfos): [string?, string?, string?] {
    if (
      (assetObject.status !== ObjectStatus.Rejected && assetObject.status !== ObjectStatus.RejectedAuto) ||
      assetObject.statusHistory === null ||
      assetObject.statusHistory.length === 0
    )
      return [undefined, undefined, undefined];

    // if sort is needed uncomment and code with moment(date1).isAfter(date2)
    // const assetStatusHistory = assetObject.statusHistory.sort((a, b) => {
    //     moment()
    // })
    const lastStatusHistory = assetObject.statusHistory.at(-1);
    const rejectedBy = lastStatusHistory!.userName! === "Unknown" ? "System" : lastStatusHistory!.userName!;
    const rejectedAt = GetFormattedDateTime(lastStatusHistory!.date);
    // TODO : keep this comment or use lastStatusHistory.comment ?
    const rejectedComment =
      lastStatusHistory!.comment || GetMetadataByTagName(assetObject, "ingestResultMessage")?.value || "";

    return [rejectedBy, rejectedAt, rejectedComment];
  }

  private getInfosFromAsset(assetObject: DbAssetObjectInfos, status: ObjectStatus): [string?, string?, string?] {
    if (
      status === ObjectStatus.Deleted &&
      (assetObject.status !== ObjectStatus.Deleted ||
        assetObject.statusHistory === null ||
        assetObject.statusHistory.length === 0)
    )
      return [undefined, undefined, undefined];

    if (
      status === ObjectStatus.Accepted &&
      (assetObject.status !== ObjectStatus.Accepted ||
        assetObject.statusHistory === null ||
        assetObject.statusHistory.length === 0)
    )
      return [undefined, undefined, undefined];

    const lastStatusHistory = assetObject.statusHistory!.at(-1);
    const doneBy = lastStatusHistory!.userName! === "Unknown" ? "System" : lastStatusHistory!.userName!;
    const doneAt = GetFormattedDateTime(lastStatusHistory!.date);
    const doneComment = lastStatusHistory!.comment || "";

    return [doneBy, doneAt, doneComment];
  }

  //------Methods from ApiCLient (useless)------

  async GetMetadataFields(): Promise<GetMetadataFieldsResponse> {
    return await this.assetApiClient.GetMetadataFields();
  }
  async GetMetadataFieldsFlat(): Promise<GetMetadataFieldsFlatResponse> {
    return await this.assetApiClient.GetMetadataFieldsFlat();
  }
  async GetLayerMetadataList(layer: ObjectLayer): Promise<GetLayerMetadataListResponse> {
    return await this.assetApiClient.GetLayerMetadataList(layer);
  }
  async GetMetadataLanguageField(): Promise<GetPlatformLanguageCodes> {
    return await this.assetApiClient.GetMetadataLanguageField();
  }
  async GetMetadataFieldsByObjectId(objectId: number): Promise<GetMetadataFieldsByObjectIdResponse> {
    return await this.assetApiClient.GetMetadataFieldsByObjectId(objectId);
  }
  async GetMetadataFieldsByObjectIds(objectIds: number[]): Promise<GetMetadataFieldsByObjectIdResponse> {
    return await this.assetApiClient.GetMetadataFieldsByObjectIds(objectIds);
  }
  async UpdateMetadataFields(request: UpdateMetadataFieldsRequest): Promise<UpdateMetadataResponse> {
    return await this.assetApiClient.UpdateMetadataFields(request);
  }
  async UpdateObjectsMetadataFields(request: UpdateObjectsMetadataFieldsRequest): Promise<UpdateMetadataResponse> {
    return await this.assetApiClient.UpdateObjectsMetadataFields(request);
  }
  async DeleteMetadataFields(request: UpdateMetadataFieldsRequest): Promise<UpdateMetadataResponse> {
    return await this.assetApiClient.DeleteMetadataFields(request);
  }
  async RemoveCulturesFromMetadata(objectId: number, cultureIds: number[]): Promise<UpdateMetadataResponse> {
    return await this.assetApiClient.RemoveCulturesFromMetadata(objectId, cultureIds);
  }
  async GetTitleInfosByObjectId(objectId: number): Promise<GetGraphResponse> {
    return await this.assetApiClient.GetTitleInfosByObjectId(objectId);
  }
  async GetTitleInfosByObjectIds(objectIds: number[]): Promise<SearchResponse> {
    return await this.assetApiClient.GetTitleInfosByObjectIds(objectIds);
  }
  async GetObjectById(objectId: number): Promise<GetGraphResponse> {
    if (cacheService.GetPlatformMode() == PlatformMode.Browser)
      return await this.assetApiClient.GetObjectLightById(objectId, 2);
    return await this.assetApiClient.GetObjectById(objectId);
  }
  async GetObjectLightById(objectId: number, childRecursiveDepth: number = 1): Promise<GetGraphResponse> {
    return await this.assetApiClient.GetObjectLightById(objectId, childRecursiveDepth);
  }
  async ListLastObjects(layer: ObjectLayer, maxItems: number): Promise<SearchResponse> {
    return await this.assetApiClient.ListLastObjects(layer, maxItems);
  }
  async ExportObjectMetadata(objectId: number, includeChildren: boolean): Promise<MetadataExportResponse> {
    return await this.assetApiClient.ExportObjectMetadata(objectId, includeChildren);
  }
  async ListHeadObjects(): Promise<SearchResponse> {
    return await this.assetApiClient.ListHeadObjects();
  }
  async GetModifiedObjectsByDateRange(startDate: string, endDate: string): Promise<SearchResponse> {
    return await this.assetApiClient.GetModifiedObjectsByDateRange(startDate, endDate);
  }
  async CreateByTemplate(objects: CreateRequest[]): Promise<CreateResponse> {
    return await this.assetApiClient.CreateByTemplate(objects);
  }
  async CreateStandalone(request: CreateStandaloneRequest): Promise<CreateStandaloneResponse> {
    return await this.assetApiClient.CreateStandalone(request);
  }
  async CreateClip(request: CreateClipRequest): Promise<CreateClipResponse> {
    return await this.assetApiClient.CreateClip(request);
  }
  async UpdateClipById(request: UpdateClipByIdRequest): Promise<CreateClipResponse> {
    return await this.assetApiClient.UpdateClipById(request);
  }
  async GroupAssets(request: GroupAssetsRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.GroupAssets(request);
  }
  async Rename(request: RenameRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.Rename(request);
  }
  async DeleteObjectById(objectId: number): Promise<GenericResponseStd> {
    return await this.assetApiClient.DeleteObjectById(objectId);
  }

  async DeleteObjectsById(objectsIds: number[]): Promise<boolean> {
    for (let i = 0; i < objectsIds.length; i++) {
      const response = await this.DeleteObjectById(objectsIds[i]);
      if (!response.success) return false;
    }

    return true;
  }
  async ChangeStatus(request: ChangeStatusRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.ChangeStatus(request);
  }
  async ChangeFollower(objectId: number, userId: number): Promise<GenericResponseStd> {
    return await this.assetApiClient.ChangeFollower(objectId, userId);
  }
  async DownloadCreatedObjectsByDateRangeAsCSV(
    startDateAsString: string,
    endDateAsString: string
  ): Promise<GenericResponseStd> {
    return await this.assetApiClient.DownloadCreatedObjectsByDateRangeAsCSV(startDateAsString, endDateAsString);
  }
  async CopyObjectAsync(request: CopyObjectRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.CopyObjectAsync(request);
  }
  async MoveObjectAsync(request: MoveObjectRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.MoveObjectAsync(request);
  }
  async SaveObjects(objectIds: number[]): Promise<GenericResponseStd> {
    return await this.assetApiClient.SaveObjects(objectIds);
  }
  async SaveObjectsByType(objectType: ObjectType): Promise<GenericResponseStd> {
    return await this.assetApiClient.SaveObjectsByType(objectType);
  }
  async SwitchObjectClass(request: SwitchClassRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.SwitchObjectClass(request);
  }
  async SetUploader(objectId: number): Promise<GenericResponseStd> {
    return await this.assetApiClient.SetUploader(objectId);
  }
  async SetFollowers(request: SetFollowersRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.SetFollowers(request);
  }
  async SetConfidentialityInfos(request: SetConfidentialityInfosRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.SetConfidentialityInfos(request);
  }
  async SetTagsProperty(request: SetTagsPropertyRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.SetTagsProperty(request);
  }
  async WhoIam(objectId: number): Promise<GenericResponseStd> {
    return await this.assetApiClient.WhoIam(objectId);
  }
  async GetMetrics(objectId: number): Promise<GetChildrenSizeGroupedByObjectTypeResponse> {
    return await this.assetApiClient.GetMetrics(objectId);
  }
  async GetQuotas(objectId: number): Promise<GetObjectQuotasResponse> {
    return await this.assetApiClient.GetQuotas(objectId);
  }
  async GetClipsByObjectId(objectId: number): Promise<SearchAdvancedResponse> {
    return await this.assetApiClient.GetClipsByObjectId(objectId);
  }
  async GetClipsByObjectIdWithEpisodeNumber(objectId: number, episodeNb: number): Promise<SearchAdvancedResponse> {
    return await this.assetApiClient.GetClipsByObjectIdWithEpisodeNumber(objectId, episodeNb);
  }
  async GetMarkerEnums(): Promise<GetMarkersByObjectIdResponseDto> {
    let response: GetMarkerEnumsResponse = await this.assetApiClient.GetMarkerEnums();
    let result: GetMarkersByObjectIdResponseDto = {
      families: response.families?.map<FamilyMarkerDto>((x: DbAssetMarkerFamilyInfos) => {
        return {
          name: x.name!,
          id: x.id,
        };
      })!,
      types: [],
    };
    if (response.types !== null) {
      delete (response.types as any).$type;
      Object.entries(response.types).forEach(
        ([key, value]) =>
          (result.types = result.types.concat(
            value.map<TypeMarkerDto>((x: DbAssetMarkerTypeInfos) => {
              return {
                name: x.name!,
                id: x.id,
                familyId: x.familyId!,
              };
            })
          ))
      );
    }
    return result;
  }
  async GetMarkersByObjectId(objectId: number): Promise<GetMarkersByObjectIdResponse> {
    return await this.assetApiClient.GetMarkersByObjectId(objectId);
  }
  async ImportMarkers(request: ImportMarkersRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.ImportMarkers(request);
  }
  async ImportMarkersWithStagging(request: ImportMarkersRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.ImportMarkersWithStagging(request);
  }
  async AddMarkerOnObjectId(request: AddMarkerByObjectIdRequest): Promise<AddMarkerByObjectIdResponse> {
    return await this.assetApiClient.AddMarkerOnObjectId(request);
  }
  async UpdateMarkerOnObjectId(request: AddMarkerByObjectIdRequest): Promise<AddMarkerByObjectIdResponse> {
    return await this.assetApiClient.UpdateMarkerOnObjectId(request);
  }
  async AddOrUpdateMarkersByObjectId(request: AddOrUpdateMarkersByObjectIdRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.AddOrUpdateMarkersByObjectId(request);
  }
  async DuplicateMarkerFromMarkerId(request: DuplicateMarkerFromMarkerIdRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.DuplicateMarkerFromMarkerId(request);
  }
  async DeleteMarkersByObjectId(objectId: number): Promise<GenericResponseStd> {
    return await this.assetApiClient.DeleteMarkerByMarkerId(objectId);
  }
  async DeleteMarkerByMarkerId(objectId: number): Promise<GenericResponseStd> {
    return await this.assetApiClient.DeleteMarkerByMarkerId(objectId);
  }
  async GetBundleMakerComputeBaseMetadata(titleId: number): Promise<GetBundleMakerMetadataResponse> {
    return await this.assetApiClient.GetBundleMakerComputeBaseMetadata(titleId);
  }
  async GetBundleMakerComputeCulturedMetadata(
    request: GetBundleMakerComputeMetadataRequest
  ): Promise<GetBundleMakerMetadataResponse> {
    return await this.assetApiClient.GetBundleMakerComputeCulturedMetadata(request);
  }
  async SetDefaultPermissions(request: SetDefaultPermissionsRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.SetDefaultPermissions(request);
  }
  async SetSpecificPermissions(request: SetSpecificPermissionsRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.SetSpecificPermissions(request);
  }
  async DeleteSpecificPermissions(request: DeleteSpecificPermissionRequest): Promise<GenericResponseStd> {
    return await this.assetApiClient.DeleteSpecificPermissions(request);
  }
  async GetPermissionsByObjectId(objectId: number): Promise<GetPermissionsByObjectIdResponse> {
    return await this.assetApiClient.GetPermissionsByObjectId(objectId);
  }
  async PutToTrash(objectId: number): Promise<GenericResponseStd> {
    return await this.assetApiClient.PutToTrash(objectId);
  }
  async ClearTrash(objectIds: number[]): Promise<GenericResponseStd> {
    return await this.assetApiClient.ClearTrash(objectIds);
  }
  async UnTrash(objectId: number): Promise<GenericResponseStd> {
    return await this.assetApiClient.UnTrash(objectId);
  }
  async GetTrash(): Promise<SearchResponse> {
    return await this.assetApiClient.GetTrash();
  }
  async GetCollectionWishList(): Promise<DbObjectCollectionInfos[]> {
    const wishList = await (await this.assetApiClient.ListCollectionByType(CollectionType.Whishlist)).results;

    return wishList === null ? [] : wishList;
  }
  async GetCollectionStoreFront(): Promise<DbObjectCollectionInfos[]> {
    const storefrontCollectionsList = await (
      await this.assetApiClient.ListCollectionByType(CollectionType.Storefront)
    ).results;

    return storefrontCollectionsList === null ? [] : storefrontCollectionsList;
  }
  async ListCollection(): Promise<DbObjectCollectionInfos[]> {
    const Collections = await (await this.assetApiClient.ListCollection()).results;

    return Collections === null ? [] : Collections;
  }

  //   async CreateCollectionUnique(
  //     name: string,
  //     type: CollectionType,
  //     targetGroupId?: number,
  //     objectId?: number
  //   ): Promise<GenericResponseStd> {
  //     return this.CreateCollection(
  //       name,
  //       type,
  //       targetGroupId ? [targetGroupId] : undefined,
  //       objectId ? [objectId] : undefined
  //     );
  //   }

  async CreateCollection(
    name: string,
    description: string,
    type: CollectionType,
    randomDisplay?: boolean,
    location?: CollectionLocation,
    isPublished?: boolean,
    targetGroupIds?: number[],
    targetUserIds?: number[],
    objectIds?: number[]
  ): Promise<GenericResponseStd> {
    return this.assetApiClient.CreateCollection(
      new CollectionRequest({
        name: name,
        description: description,
        location: location,
        type: type,
        targetGroupIds: targetGroupIds,
        targetUserIds: targetUserIds,
        objectIds: objectIds,
        isPublished: isPublished,
        randomDisplay: randomDisplay,
        id: -500,
      })
    );
  }

  async UpdateCollection(
    id: number,
    name: string,
    description: string,
    type: CollectionType,
    location?: CollectionLocation,
    randomDisplay?: boolean,
    isPublished?: boolean,
    targetGroupIds?: number[],
    targetUserIds?: number[],
    objectIds?: number[]
  ): Promise<GenericResponseStd> {
    return this.assetApiClient.UpdateCollection(
      new CollectionRequest({
        name: name,
        type: type,
        description: description,
        location: location,
        targetGroupIds,
        targetUserIds,
        objectIds,
        id: id,
        randomDisplay,
        isPublished,
      })
    );
  }
  async GetCollection(id: number): Promise<DbObjectCollectionInfos> {
    const collection = (await this.assetApiClient.GetCollection(id)).result;

    return collection === null ? new DbObjectCollectionInfos() : collection;
  }
  async AddObjectIdsToCollection(collectionId: number, objectIds: number[]): Promise<GenericResponseStd> {
    return this.assetApiClient.AddObjectIdsToCollection(collectionId, objectIds);
  }
  async DeleteCollection(collectionId: number): Promise<GenericResponseStd> {
    return this.assetApiClient.DeleteCollection(collectionId);
  }
  async DeleteFromCollection(collectionId: number, objectIds: number[]): Promise<GenericResponseStd> {
    return this.assetApiClient.DeleteFromCollection(collectionId, objectIds);
  }
  async GetChildrenByObjectId(
    parentObjectId: number,
    size: number,
    excludeIds?: number[],
    page?: number,
    onlyObjectTypes?: ObjectType[]
  ): Promise<GetChildrenResponse> {
    return this.assetApiClient.GetChildrenByObjectId(
      parentObjectId,
      excludeIds ?? [],
      size,
      page,
      onlyObjectTypes ?? []
    );
  }
  async GetTreeViewChildren(
    parentObjectId: number,
    size: number,
    excludeIds?: number[]
  ): Promise<{ total: number; add: TreeGenBuilderItemNodeType[] }> {
    const response: GetChildrenResponse = await this.assetApiClient.GetChildrenByObjectId(
      parentObjectId,
      excludeIds ?? [],
      size
    );
    return {
      total: response.totalChildrenAvailable!,
      add: response.children?.map((x) => this.ConvertDataNodeTypeToTreeGen(this.ConvertObjectToDataTree(x))) ?? [],
    };
  }
  async SearchCollectionByObjectIds(objectIds: number[]): Promise<DbObjectCollectionInfos[]> {
    if (objectIds.length === 0) return [];
    const collection = (await this.assetApiClient.SearchCollectionByObjectIds(objectIds)).results;

    return collection || [];
  }
  async GenerateCompilation(request: GenerateCompilationRequest): Promise<GenerateCompilationResponse> {
    return this.assetApiClient.GenerateCompilation(request);
  }
  async UpdateCompilation(request: UpdateCompilationRequest): Promise<GenerateCompilationResponse> {
    return this.assetApiClient.UpdateCompilation(request);
  }
  async GetStatusTransitions(objectId: number): Promise<GetStatusTransitionsResponse> {
    return await this.assetApiClient.GetStatusTransitions(objectId);
  }
  async ToggleMetadataViewFilterById(objectId: number, viewId: number): Promise<GenericResponseStd> {
    return await this.assetApiClient.ToggleMetadataViewFilterById(objectId, viewId);
  }
  async CheckUpdateMetadataFields(
    request: CheckUpdateMetadataFieldsRequest
  ): Promise<CheckUpdateMetadataFieldsResponse> {
    return this.assetApiClient.CheckUpdateMetadataFields(request);
  }

  async SetPosterResource(
    titleId: number,
    resourceId: number,
    resourceLocation: TitlePosterLocation
  ): Promise<GenericResponseStd> {
    const resource: TitlePosterResource = createTitlePosterResource(resourceId, resourceLocation);
    return this.assetApiClient.ReplaceLinkedResource({ objectId: titleId, resource: resource });
  }

  async SetCoverResource(
    titleId: number,
    resourceId: number,
    resourceLocation: TitleCoverLocation
  ): Promise<GenericResponseStd> {
    const resource: TitleCoverResource = createTitleCoverResource(resourceId, resourceLocation);
    return this.assetApiClient.ReplaceLinkedResource({ objectId: titleId, resource: resource });
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.assetApiClient.GetApiUrl();
  }

  FormatMetadataRow(row: AssetMetadataRow, showLabelIfValueDiffers: boolean = true): string {
    if (!row) return "-";

    let field: DbMetadataFieldInfos | undefined = undefined;

    if (row.type === BaseMetadataType.DbDateTimeMetadataValueInfos) {
      if (row.value === null || row.value === undefined) return "-";
      if (row.tagName === "productionDate") return moment(row.value).format(GlobalConst.MOMENT_DATE_FORMAT_YEARONLY);

      return moment(row.value).format(GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS);
    } else if (row.type === BaseMetadataType.DbBoolMetadataValueInfos) return row.value ? "Yes" : "No";
    else if (row.type === BaseMetadataType.DbStringMultiMetadataValueInfos) {
      if (!row.value || row.value.length <= 0) return "-";
      field = cacheService.GetMetadata().find((x) => x.id === row.id);
      if (field && field.values && field.values.length > 0) {
        return row.value
          .map((v) => {
            let ValueWithLabel = field!.values!.find((x) => x.value === v);
            if (!ValueWithLabel || ValueWithLabel.label === ValueWithLabel.value) return v;
            return ValueWithLabel.label + " (" + ValueWithLabel.value + ")";
          })
          .join(", ");
      }
      return row.value.join(", ");
    } else if (row.type === BaseMetadataType.DbLanguageCodeMetadataValueInfos)
      return row.value
        ? row.value.label + (row.value.label !== row.value.value ? " (" + row.value.value + ")" : "")
        : "-";
    else if (row.type === BaseMetadataType.DbLanguageCodeMultiMetadataValueInfos)
      return row.value && row.value.length > 0 ? row.value.map((v) => v.label + " (" + v.value + ")").join(", ") : "-";
    else if (row.type === BaseMetadataType.DbAudioChannelsMetadataValueInfos) return row?.value?.length + " channels";
    else if (row.type === BaseMetadataType.DbAnyObjectMultiMetadataValueInfos)
      return row.value && row.value.length > 0 ? row.value.map((v) => v).join(", ") : "-";
    else if (row.type === BaseMetadataType.DbCastsMetadataValueInfos)
      return row.value && row.value.length > 0
        ? row.value.map((v) => `${v.name} ${v.lastname} (${v.function})`).join(", ")
        : "-";
    else if (row.type === BaseMetadataType.DbSynopsesMetadataValueInfos)
      return row.value && row.value.text ? row.value.text : "-";

    if (field === undefined) field = cacheService.GetMetadata().find((x) => x.id === row.id);

    if (field && field.values && field.values.length > 0) {
      let valueWithLabel: DbMetadataFieldValueInfos | undefined = field.values.find((x) => x.value === row.value);

      if (valueWithLabel)
        return showLabelIfValueDiffers &&
          valueWithLabel.label &&
          row.value &&
          valueWithLabel.label.toLowerCase() !== row.value.toLowerCase()
          ? `${valueWithLabel.label} (${valueWithLabel.value})`
          : row.value ?? "-";
    }

    return row.value ?? "-";
  }
}
